import {settings} from './variables.js'
var apiBaseUrl = settings.apiBaseUrl

var Autocomplete = function(options) {
      this.form_selector = options.form_selector
      this.url = options.url || '/search/autocomplete/'
      this.delay = parseInt(options.delay || 300)
      this.minimum_length = parseInt(options.minimum_length || 3)
      this.form_elem = null
      this.query_box = null
    }

    Autocomplete.prototype.setup = function() {
      var self = this

      this.form_elem = $(this.form_selector)
      this.query_box = this.form_elem.find('input[name=q]')
      this.close_btn = $('.close-search')

      // Watch the input box.
      this.query_box.on('keyup', function(event) {

        var query = self.query_box.val();

        if(query.length < self.minimum_length) {
          return false;
        }
        if (event.key == 'Enter'){

        }
          else{
            self.fetch(query)
        }
        ;
      })

    }

    Autocomplete.prototype.fetch = function(query) {
      var self = this

      $.ajax({
        url: apiBaseUrl + this.url
      , data: {
          'q': query
        }
      , success: function(data) {
          self.show_results(data)
        }
      })
    }

    Autocomplete.prototype.show_results = function(data) {
      // Remove any existing results.
      $('.tip-container').remove()

      var results = data.results || []
      var results_wrapper = $('<div class="tip-container"></div>')
      var base_elem = $('<div class="tip-item"><a href="#" class="tip-item__link ac-result"><img class="tip-item__img" src="" /></span><span><span class="tip-item__text"></span><span class="tip-item__code"></span></span><span class="tip-item__price"></span><span class="tip-item__icon"></a></div>')

      if(results.length > 0) {
        for(var res_offset in results) {
          var elem = base_elem.clone()
          // Don't use .html(...) here, as you open yourself to XSS.
          // Really, you should use some form of templating.
          elem.find('.ac-result').find('.tip-item__text').text(results[res_offset].title)
          elem.find('.ac-result').find('.tip-item__code').text(results[res_offset].code)
          elem.find('.ac-result').find('.tip-item__price').text(results[res_offset].price)
          elem.find('.ac-result').find('.tip-item__img').attr('src', apiBaseUrl + results[res_offset].image)
          elem.find('.ac-result').attr('href', results[res_offset].link)
          results_wrapper.append(elem)
        }
      }
      else {
        var elem = base_elem.clone()
        elem.text("Ничего не найдено")
        results_wrapper.append(elem)
      }

      this.query_box.after(results_wrapper)
    }

jQuery(document).ready(function() {
      window.autocomplete = new Autocomplete({
        form_selector: '.autocomplete-me'
      })
      window.autocomplete.setup()
})

jQuery( ".autocomplete-me--desktop input" ).on( "focus", function() {
  window.autocomplete_desktop = new Autocomplete({
    form_selector: '.autocomplete-me--desktop'
  })
  window.autocomplete_desktop.setup()

  console.log(window.autocomplete_desktop)
});

jQuery( ".search-field__close-btn" ).on( "click", function() {
  jQuery(".autocomplete-me--desktop .tip-container").remove()
  jQuery(".autocomplete-me--desktop").removeClass("search-field--expand")
  return true
});